import React, { useState, useEffect } from "react";
import { useFormContext, Controller } from "react-hook-form";
import Input from "Components/UI/Input";
import { useNationalityQuery } from "AppQuries/master/Nationality/get-all-nationalities";
import { useRelationQuery } from "AppQuries/master/Relationship/get-all-relations";
import dayjs from "dayjs";
import { useCpfTypesQuery } from "AppQuries/master/CpfType/get-all-cpf-types";
import { useRaceQuery } from "AppQuries/master/Race/get-all-race";
import { useGetAllDepartmentQuery } from "AppQuries/master/Department/get-all-departments";
import { useGetAllDesignationQuery } from "AppQuries/master/Designation/get-all-designations";
import { useGetGroupsQuery } from "AppQuries/master/Group/group";
import { useGetPassTypeQuery } from "AppQuries/master/PassType/pass-type";
import { Info } from "react-feather";
import PPEDetails from "./Components/PPEDetails";
import EmployeeLoginDetails from "./Components/EmployeeLoginDetails";
import { useGetLocationQuery } from "AppQuries/master/Location/location";
import { useGetEmploymentTypesQuery } from "AppQuries/master/EmploymentType/employmentType";
import { useGetContractTypesQuery } from "AppQuries/master/ContractType/contract-type";
import CPFDetails from "./Components/CPFDetails";
import { useGetEmployeeStatusesQuery } from "AppQuries/master/employee-status";
import {
  useFormattedDepartmentOption,
  useFormattedDesignationOption,
  useFormattedEmpContractOption,
  useFormattedEmpGroupOption,
  useFormattedEmploymentTypeOption,
  useFormattedEmpStatusOption,
  useFormattedEmpTypeOption,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import {
  useFormattedMomTradeOption,
  useFormattedNationalOption,
  useFormattedTradeOption,
  useFormattedProjectOption,
  useFormattedRaceOption,
  useFormattedWorkingDaysTypeOption,
} from "core/Operations/formattedOption/useFormattedMasterOptions";
import { Select } from "antd";
const dateFormat = "YYYY-MM-DD";
const SkilledOrUnskilledOptions = [
  { id: "1", label: "Skilled", value: "S" },
  { id: "2", label: "UnSkilled", value: "U" },
];

// const restDayOptions = [
//   // { id: "1", label: "Sunday", value: "Sunday" },
//   // { id: "2", label: "Monday", value: "Monday" },
//   // { id: "3", label: "Tuesday", value: "Tuesday" },
//   // { id: "4", label: "Wednesday", value: "Wednesday" },
//   // { id: "5", label: "Thursday", value: "Thursday" },
//   // { id: "6", label: "Friday", value: "Friday" },
//   // { id: "7", label: "Saturday", value: "Saturday" },
//   { id: "1", label: "Sunday-1", value: "Sunday" },
//   { id: "2", label: "Monday-1", value: "Monday" },
//   { id: "3", label: "Tuesday-1", value: "Tuesday" },
//   { id: "4", label: "Wednesday-1", value: "Wednesday" },
//   { id: "5", label: "Thursday-1", value: "Thursday" },
//   { id: "6", label: "Friday-1", value: "Friday" },
//   { id: "7", label: "Saturday-1", value: "Saturday" },
// ];
const restDayOptions1 = [
  { id: "1", label: "Sunday", value: "Sunday-1" },
  // { id: "2", label: "Monday", value: "Monday-1" },
  // { id: "3", label: "Tuesday", value: "Tuesday-1" },
  // { id: "4", label: "Wednesday", value: "Wednesday-1" },
  // { id: "5", label: "Thursday", value: "Thursday-1" },
  // { id: "6", label: "Friday", value: "Friday-1" },
  { id: "7", label: "Saturday", value: "Saturday-1" },
];

const restDayOptions = [
  { id: "1", label: "Sunday-1", value: "Sunday-1" },
  // { id: "2", label: "Monday-1", value: "Monday-1" },
  // { id: "3", label: "Tuesday-1", value: "Tuesday-1" },
  // { id: "4", label: "Wednesday-1", value: "Wednesday-1" },
  // { id: "5", label: "Thursday-1", value: "Thursday-1" },
  // { id: "6", label: "Friday-1", value: "Friday-1" },
  { id: "7", label: "Saturday-1", value: "Saturday-1" },
  { id: "8", label: "Sunday-0.5", value: "Sunday-0.5" },
  // { id: "9", label: "Monday-0.5", value: "Monday-0.5" },
  // { id: "10", label: "Tuesday-0.5", value: "Tuesday-0.5" },
  // { id: "11", label: "Wednesday-0.5", value: "Wednesday-0.5" },
  // { id: "12", label: "Thursday-0.5", value: "Thursday-0.5" },
  // { id: "13", label: "Friday-0.5", value: "Friday-0.5" },
  { id: "14", label: "Saturday-0.5", value: "Saturday-0.5" },
];

const isSupervisorOptions = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];
const genders = [
  { label: "Male", value: "M", id: "M" },
  { label: "Female", value: "F", id: "M" },
  { label: "Trans", value: "T", id: "M" },
];

const marriagestatus = [
  { id: "1", label: "Single", value: "Single" },
  { id: "2", label: "Married", value: "Married" },
  { id: "3", label: "Widowed", value: "Widowed" },
];

const activestatus = [
  { id: "1", label: "Yes", value: true },
  { id: "0", label: "No", value: false },
];

const OfficialInformation = () => {
  const {
    control,
    formState: { errors },
    watch,
    setValue,
    trigger,
    clearErrors,
  } = useFormContext();
  // const companyCode = watch("companyCode");
  // const locationCode = watch("locationCode");

  const workingDaysOption = useFormattedWorkingDaysTypeOption(
    watch("companyCode")
  );
  const netcoTradeOptions = useFormattedTradeOption(watch("companyCode"));
  const momTradeOptions = useFormattedMomTradeOption(watch("companyCode"));
  const projectOptions = useFormattedProjectOption({
    companyCode: watch("companyCode"),
    locationCode: watch("locationCode"),
  });

  const { data: locations } = useGetLocationQuery({
    companyCode: watch("companyCode"),
  });

  const empTypeOptions = useFormattedEmpTypeOption(watch("companyCode"));

  const employeementStatusOptions = useFormattedEmpStatusOption(
    watch("companyCode")
  );

  const locationOptions = Array.isArray(locations)
    ? locations
        // .filter((o) => o.isActive === true)
        .map((o) => ({
          id: o.locationCode,
          label: o.locationName,
          value: o.locationCode,
        }))
    : [];

  const departmentOptions = useFormattedDepartmentOption(watch("companyCode"));

  const designationptions = useFormattedDesignationOption(watch("companyCode"));
  const [selectedLeaveDays, setSelectedLeaveDays] = useState([]);
  useEffect(() => {
    // if (watch("restDay")?.split(",")?.length) {
    //   const defaultSelections = restDayOptions.filter((option) =>
    //     watch("restDay").includes(option.value)
    //   );
    //   setSelectedLeaveDays(defaultSelections);
    // } else
    const defaultSelections = restDayOptions.filter((option) =>
      watch("restDay")?.includes(option.value)
    );
    setSelectedLeaveDays(defaultSelections);
  }, [watch("restDay")]);

  const raceOptions = useFormattedRaceOption(watch("companyCode"));

  const employmentTypeOptions = useFormattedEmploymentTypeOption(
    watch("companyCode")
  );

  const contarctTypeOptions = useFormattedEmpContractOption(
    watch("companyCode")
  );

  const nationOptions = useFormattedNationalOption(watch("companyCode"));

  const groupOptions = useFormattedEmpGroupOption(watch("companyCode"));

  const setBase64Value = (value) => {
    setValue("employeePhoto", value);
  };

  return (
    <>
      <div className="addproduct-icon list icon">
        <h5>
          <Info className="add-info" />
          <span>Employee Information</span>
        </h5>
      </div>
      <div className="form-row row mb-3">
        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="fullName"
            type="text"
            placeholder="Full Name"
            className={`form-control ${errors.fullName ? "is-invalid" : ""}`}
            label="Full Name"
            labelClassName="form-label"
            required={true}
            requiredMessage="Fullname is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="uniqueId"
            type="text"
            placeholder="Unique ID"
            className={`form-control ${errors.uniqueId ? "is-invalid" : ""}`}
            label="Unique ID"
            labelClassName="form-label"
            required={true}
            requiredMessage="Unique ID is required"
            readOnly={watch("employeeCode") ? true : false}
            defaultValue={watch("uniqueId")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="employeeType"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.employeeType ? "is-invalid" : ""
            }`}
            label="Employee Type"
            labelClassName="form-label"
            optionData={empTypeOptions?.map((opt) => {
              return {
                label: opt.label,
                value: opt.value.toString(),
              };
            })}
            required={true}
            requiredMessage="Employee Type is required"
            onSelect={(selectedOption) => {
              setValue("employeeType", selectedOption ? selectedOption : null);
              // if (selectedOption === "3") {
              setValue("residentialType", "");
              trigger("residentialType");
              // }
              trigger("employeeType");
              trigger("icno");
              trigger("finNumber");
            }}
            defaultValue={{ value: watch("employeeType") }}
          />
        </div>
        {watch("employeeType") !== "3" ? (
          <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
            <Input
              name="icno"
              type="text"
              placeholder="NRIC/IC No"
              className={`form-control ${errors.icno ? "is-invalid" : ""}`}
              label="NRIC/IC No"
              labelClassName="form-label"
              required={watch("employeeType") !== "3" ? true : false}
              requiredMessage="icno is required"
              onKeyUp={(e) => {
                trigger("icno");
              }}
              value={watch("icno")}
            />
          </div>
        ) : (
          <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
            <Input
              name="finNumber"
              type="text"
              placeholder="FIN No"
              className={`form-control ${errors.finNumber ? "is-invalid" : ""}`}
              label="FIN No"
              labelClassName="form-label"
              required={watch("employeeType") === "3" ? true : false}
              requiredMessage="Fin Number is required"
              onKeyUp={(e) => {
                trigger("finNumber");
              }}
              value={watch("finNumber")}
            />
          </div>
        )}

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="gender"
            type="commonSelect"
            placeholder=""
            className={`form-control ${errors.gender ? "is-invalid" : ""}`}
            label="Gender"
            labelClassName="form-label"
            optionData={genders}
            required={false}
            requiredMessage="Gender is required"
            onChange={(selectedOption) => {
              setValue("gender", selectedOption ? selectedOption : null);
              trigger("gender");
            }}
            defaultValue={watch("gender")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="race"
            type="commonSelect"
            placeholder=""
            className={`form-control ${errors.race ? "is-invalid" : ""}`}
            label="Race"
            labelClassName="form-label"
            optionData={raceOptions}
            required={false}
            requiredMessage="Race is required"
            onChange={(selectedOption) => {
              setValue("race", selectedOption ? selectedOption : null);
              trigger("race");
            }}
            defaultValue={watch("race")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="nationality"
            type="commonSelect"
            placeholder=""
            className={`form-control ${errors.nationality ? "is-invalid" : ""}`}
            label="Nationality"
            labelClassName="form-label"
            optionData={nationOptions}
            required={true}
            requiredMessage="Nationality is required"
            onChange={(selectedOption) => {
              setValue("nationality", selectedOption ? selectedOption : null);
              trigger("nationality");
            }}
            defaultValue={watch("nationality")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="departmentCode"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.departmentCode ? " is-invalid" : ""
            }`}
            label="Department"
            labelClassName="form-label"
            optionData={departmentOptions}
            required={true}
            requiredMessage="Department is required"
            onChange={(selectedOption) => {
              setValue(
                "departmentCode",
                selectedOption ? selectedOption : null
              );
              clearErrors("departmentCode");
            }}
            defaultValue={watch("departmentCode")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="designationCode"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.designationCode ? " is-invalid" : ""
            }`}
            label="Designation"
            labelClassName="form-label"
            optionData={designationptions}
            required={true}
            requiredMessage="Designation is required"
            onChange={(selectedOption) => {
              setValue(
                "designationCode",
                selectedOption ? selectedOption : null
              );
              clearErrors("designationCode");
            }}
            defaultValue={watch("designationCode")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="jobTitle"
            type="text"
            placeholder="Job Title"
            className={`form-control ${errors.jobTitle ? "is-invalid" : ""}`}
            label="Job Title"
            labelClassName="form-label"
            required={false}
            requiredMessage="Job Title is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="confirmationDate"
            type="date"
            placeholder="Select Confirmation Date"
            className={`form-control ${
              errors.confirmationDate ? "is-invalid" : ""
            }`}
            label="Confirmation Date"
            labelClassName="form-label"
            required={false}
            requiredMessage="Confirmation Date is required"
            defaultValue={dayjs(watch("confirmationDate"), dateFormat) || ""}
            dateFormat="DD/MM/YYYY"
          />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="joinDate"
            type="date"
            placeholder="Select Start Date/Onboarding Date"
            className={`form-control ${errors.joinDate ? "is-invalid" : ""}`}
            label="Start Date/Onboarding Date"
            labelClassName="form-label"
            required={false}
            requiredMessage="Join Date is required"
            defaultValue={dayjs(watch("joinDate"), dateFormat) || ""}
            dateFormat="DD/MM/YYYY"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="resignedDate"
            type="date"
            placeholder="Select Resigned Date"
            className={`form-control ${errors.resignedDate ? "is-invalid" : ""}`}
            label="Resigned Date"
            labelClassName="form-label"
            required={false}
            requiredMessage="Resigned Date is required"
            defaultValue={dayjs(watch("resignedDate"), dateFormat) || ""}
            dateFormat="DD/MM/YYYY"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="locationCode"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.locationCode ? "is-invalid" : ""
            }`}
            label="Company"
            labelClassName="form-label"
            optionData={locationOptions}
            required={false}
            requiredMessage="location code is required"
            onChange={(selectedOption) => {
              setValue("locationCode", selectedOption ? selectedOption : null);
              trigger("locationCode");
            }}
            defaultValue={watch("locationCode")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="groups"
            type="commonSelect"
            placeholder=""
            className={`form-control ${errors.groups ? "is-invalid" : ""}`}
            label="Shift Code"
            labelClassName="form-label"
            optionData={groupOptions}
            required={false}
            requiredMessage="groups is required"
            onChange={(selectedOption) => {
              setValue("groups", selectedOption ? selectedOption : null);
              trigger("groups");
            }}
            defaultValue={watch("groups")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="surpervisorName"
            type="text"
            placeholder="Supervisor Name"
            className={`form-control ${
              errors.surpervisorName ? "is-invalid" : ""
            }`}
            label="Supervisor Name"
            labelClassName="form-label"
            required={false}
            requiredMessage="Supervisor Name is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="employmentStatus"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.employmentStatus ? " is-invalid" : ""
            }`}
            label="Employment Status"
            labelClassName="form-label"
            optionData={employeementStatusOptions}
            required={false}
            requiredMessage="Employment Status is required"
            onChange={(selectedOption) => {
              setValue(
                "employmentStatus",
                selectedOption ? selectedOption : null
              );
              trigger("employmentStatus");
            }}
            defaultValue={watch("employmentStatus")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="jobGrade"
            type="text"
            placeholder=""
            className={`form-control ${errors.jobGrade ? "is-invalid" : ""}`}
            label="Job Grade"
            labelClassName="form-label"
            required={false}
            requiredMessage="jobGrade is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="isSupervisor"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.isSupervisor ? " is-invalid" : ""
            }`}
            label="Is Supervisor"
            labelClassName="form-label"
            optionData={isSupervisorOptions}
            required={false}
            requiredMessage="Is Supervisor is required"
            onChange={(selectedOption) => {
              setValue("isSupervisor", selectedOption);
              trigger("isSupervisor");
            }}
            defaultValue={watch("isSupervisor")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="skilledOrUnSkilled"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.skilledOrUnSkilled ? " is-invalid" : ""
            }`}
            label="Skilled Or UnSkilled"
            labelClassName="form-label"
            optionData={SkilledOrUnskilledOptions}
            required={false}
            requiredMessage="Skilled Or UnSkilled is required"
            onChange={(selectedOption) => {
              setValue(
                "skilledOrUnSkilled",
                selectedOption ? selectedOption : null
              );
              trigger("skilledOrUnSkilled");
            }}
            defaultValue={watch("skilledOrUnSkilled")}
          />
        </div>

        {/* <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="workingHoursPerDay"
            type="number"
            placeholder=""
            className={`form-control ${
              errors.workingHoursPerDay ? " is-invalid" : ""
            }`}
            label="Working Hours Per Day"
            labelClassName="form-label"
            required={true}
            requiredMessage="Working Hours Per Day is required"
            defaultValue={watch("workingHoursPerDay")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="noofworkingDaysPerWeek"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.noofworkingDaysPerWeek ? " is-invalid" : ""
            }`}
            label="No Of Working Days Per Week"
            labelClassName="form-label"
            optionData={workingDaysOption}
            required={true}
            requiredMessage="No Of Working Days Per Week is required"
            onSelect={(selectedOption) => {
              
              setValue("noofworkingDaysPerWeek", selectedOption);
              setValue("restDay", "");
              trigger("noofworkingDaysPerWeek");
              trigger("restDay");
            }}
            defaultValue={watch("noofworkingDaysPerWeek")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <div className="form-floating">
        

            <Controller
              name="restDay"
              control={control}
              render={({ field }) => {
                // Determine which options to use
                const optionsToUse =
                  watch("noofworkingDaysPerWeek") === 5.5
                    ? restDayOptions
                    : restDayOptions1;

                // Ensure filteredOptions is correctly assigned
                const filteredOptions = optionsToUse;

                const isOptionDisabled = (option) => {
                  const selectedValues = watch("restDay")?.split(",") || [];
                  const selectedDays = selectedValues.map(
                    (value) => value.split("-")[0]
                  );
                  const optionDay = option.value.split("-")[0];

                  if (selectedDays.includes(optionDay)) {
                    return true;
                  }

                  const fullDayCount = selectedValues.filter((v) =>
                    v.includes("-1")
                  ).length;
                  const halfDayCount = selectedValues.filter((v) =>
                    v.includes("-0.5")
                  ).length;

                  if (watch("noofworkingDaysPerWeek") === 5.5) {
                    if (option.label.includes("-1") && fullDayCount >= 1)
                      return true;
                    if (option.label.includes("-0.5") && halfDayCount >= 1)
                      return true;
                  } else if (watch("noofworkingDaysPerWeek") === 5) {
                    return selectedValues.length >= 2;
                  } else if (watch("noofworkingDaysPerWeek") === 6) {
                    return (
                      watch("restDay") !== "" && selectedValues.length >= 1
                    );
                  }

                  return false;
                };

                const handleSelectionChange = (values) => {
                  setValue("restDay", values.join(","));
                  trigger("restDay");
                };

                return (
                  <Select
                    {...field}
                    mode="multiple"
                    value={
                      watch("restDay") ? watch("restDay").split(",") : undefined
                    }
                    placeholder="Choose rest day"
                    onChange={handleSelectionChange}
                    className={
                      errors.restDay
                        ? "form-control is-invalid"
                        : "form-control"
                    }
                    style={{
                      width: "100%",
                      minHeight: "60px",
                      borderBottom: errors.restDay
                        ? "1px solid red"
                        : "1px solid #ced4da",
                    }}
                    allowClear
                  >
                    {filteredOptions.map((opt) => (
                      <Select.Option
                        key={opt.value}
                        value={opt.value}
                        disabled={isOptionDisabled(opt)}
                      >
                        {opt.label}
                      </Select.Option>
                    ))}
                  </Select>
                );
              }}
            />

            <label className="form-label">
              Rest Day<span className="asterisk">*</span>
            </label>
            {errors.restDay && (
              <div className="invalid-feedback">
                {errors.restDay?.message || "Invalid input"}
              </div>
            )}
          </div>
        </div> */}

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="lengthofNoticePeriod"
            type="text"
            placeholder=""
            className={`form-control ${
              errors.lengthofNoticePeriod ? "is-invalid" : ""
            }`}
            label="Length of Notice Period"
            labelClassName="form-label"
            required={false}
            requiredMessage="Length of Notice Period is required"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="probationPeriodStart"
            type="date"
            placeholder="Probation End Date"
            className={`form-control ${
              errors.probationPeriodStart ? "is-invalid" : ""
            }`}
            label="Probation Start Date"
            labelClassName="form-label"
            required={false}
            requiredMessage="Probation Start Date is required"
            defaultValue={watch("probationPeriodStart") || null}
            dateFormat="DD-MM-YYYY"
          />
        </div>
        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="probationPeriodEnd"
            type="date"
            placeholder="Probation End Date"
            className={`form-control ${
              errors.probationPeriodEnd ? "is-invalid" : ""
            }`}
            label="Probation End Date"
            labelClassName="form-label"
            required={false}
            requiredMessage="Probation Period End is required"
            defaultValue={
              dayjs(watch("probationPeriodEnd"), dateFormat) || null
            }
            dateFormat="DD-MM-YYYY"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="employmentType"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.employmentType ? " is-invalid" : ""
            }`}
            label="Employment Type"
            labelClassName="form-label"
            optionData={employmentTypeOptions}
            required={false}
            requiredMessage="Employment Type is required"
            onChange={(selectedOption) => {
              setValue("employmentType", selectedOption);
              trigger("employmentType");
            }}
            // labelInValue
            defaultValue={watch("employmentType")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="contractType"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.contractType ? " is-invalid" : ""
            }`}
            label="Contact Type"
            labelClassName="form-label"
            optionData={contarctTypeOptions}
            required={false}
            requiredMessage="Contact Type is required"
            onChange={(selectedOption) => {
              setValue("contractType", selectedOption);
              trigger("contractType");
            }}
            // labelInValue
            defaultValue={watch("contractType")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="contractExpiryDate"
            type="date"
            placeholder="Select Contract Expiry Date"
            className={`form-control ${
              errors.contractExpiryDate ? "is-invalid" : ""
            }`}
            label="Contract Expiry Date"
            labelClassName="form-label"
            required={false}
            requiredMessage="Contract Expiry Date is required"
            defaultValue={dayjs(watch("contractExpiryDate"), dateFormat) || ""}
            dateFormat="DD/MM/YYYY"
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="netcoTrade"
            type="commonSelect"
            placeholder=""
            className={`form-control ${errors.netcoTrade ? "is-invalid" : ""}`}
            label="Trade"
            labelClassName="form-label"
            optionData={netcoTradeOptions}
            required={false}
            requiredMessage="Trade is required"
            onChange={(selectedOption) => {
              setValue("netcoTrade", selectedOption ? selectedOption : null);
              trigger("netcoTrade");
            }}
            // labelInValue
            defaultValue={watch("netcoTrade")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="momTrade"
            type="commonSelect"
            placeholder=""
            className={`form-control ${errors.momTrade ? "is-invalid" : ""}`}
            label="Mom Trade"
            labelClassName="form-label"
            optionData={momTradeOptions}
            required={false}
            requiredMessage="Mom Trade is required"
            onChange={(selectedOption) => {
              setValue("momTrade", selectedOption ? selectedOption : null);
              trigger("momTrade");
            }}
            // labelInValue
            defaultValue={watch("momTrade")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="nsEligible"
            type="commonSelect"
            placeholder=""
            className={`form-control ${errors.nsEligible ? " is-invalid" : ""}`}
            label="NS Eligible"
            labelClassName="form-label"
            optionData={isSupervisorOptions}
            required={false}
            requiredMessage="NS Eligible is required"
            onChange={(selectedOption) => {
              setValue("nsEligible", selectedOption);
              trigger("nsEligible");
            }}
            defaultValue={watch("nsEligible")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="excludeTime"
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.excludeTime ? " is-invalid" : ""
            }`}
            label="Exclude Time"
            labelClassName="form-label"
            optionData={isSupervisorOptions?.map((item) => ({
              value: item.value.toString(),
              label: item.label,
            }))}
            required={true}
            requiredMessage="Exclude Time is required"
            onChange={(selectedOption) => {
              setValue("excludeTime", selectedOption);
              trigger("excludeTime");
            }}
            defaultValue={watch("excludeTime")}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          {/* <Input
            name="projectCode"
            type="commonSelect"
            placeholder=""
            className={`form-control ${errors.projectCode ? "is-invalid" : ""}`}
            label="Project"
            labelClassName="form-label"
            optionData={projectOptions}
            required={false}
            requiredMessage="Project is required"
            onChange={(selectedOption) => {
              setValue("projectCode", selectedOption ? selectedOption : null);
              trigger("projectCode");
            }}
            defaultValue={watch("projectCode")}
          /> */}
          <Input
            name={`projectCode`}
            type="commonSelect"
            placeholder="Project"
            className={`form-control ${
              errors?.projectCode ? "is-invalid" : ""
            }`}
            optionData={projectOptions?.map((opt) => ({
              label: opt.label,
              value: opt.value.toString(),
            }))}
            // onSelect={(selectedOption) => {
            //   setValue("selectedEmployees", selectedOption);
            //   trigger("selectedEmployees");
            // }}
            onChange={(selectedOptions) => {
              setValue(
                "projectCode",
                Array.isArray(selectedOptions)
                  ? selectedOptions.map((option) => option)
                  : []
              );
            }}
            // value={
            //   Array.isArray(watch("projectCode") && watch("projectCodes") !== "NULL")
            //     ? watch("projectCode").map(
            //         (option) => option !== "NULL" ? option : null
            //       )
            //     : ""
            // }
            value={
              Array.isArray(watch("projectCode")) &&
              watch("projectCode").some((v) => v !== "NULL")
                ? watch("projectCode").filter((v) => v !== "NULL")
                : []
            }
            // defaultValue={Array.isArray(watch("projectCode") && watch("projectCodes") !== "NULL") ? watch("projectCode") : }
            mode="multiple"
            label="Project"
            labelClassName="form-label"
            required={false}
            requiredMessage="Project is required"
            allowClear
            showSearch
            style={{ width: "100%", height: "auto" }}
          />
        </div>

        <div className="col-md-4 col-lg-4 col-sm-6 mb-2">
          <Input
            name="isActive"
            type="commonSelect"
            placeholder=""
            className={`form-control ${errors.isActive ? " is-invalid" : ""}`}
            label="Active Status"
            labelClassName="form-label"
            optionData={activestatus}
            required={false}
            requiredMessage="Active Status is required"
            onChange={(selectedOption) => {
              setValue("isActive", selectedOption);
              trigger("isActive");
            }}
            defaultValue={watch("isActive")}
          />
        </div>
      </div>
      {watch("employeeType") === "1" || watch("employeeType") === "2" ? (
        <div className="row mb-3">
          <CPFDetails />
        </div>
      ) : (
        ""
      )}

      <div className="row mb-3">
        <PPEDetails />
      </div>

      <div className="row mb-3">
        <EmployeeLoginDetails />
      </div>
    </>
  );
};

export default React.memo(OfficialInformation);
